/**
 * @fileoverview Homepage hero CTA copy variants.
 * @module lib/experiments/hero-cta
 */

import type { HomepageHeroCtaVariant } from "./build-flags"

/** CTA label + aria-label per variant. */
export const HERO_CTA_COPY: Record<
  HomepageHeroCtaVariant,
  { label: string; ariaLabel: string }
> = {
  control: {
    label: "Request Access",
    ariaLabel: "Request access to AdSights",
  },
  outcome_focused: {
    label: "Optimize Your Ads",
    ariaLabel: "Optimize your ad performance with AdSights",
  },
}
